import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import React, { useState } from "react";
import MCSSpace from "../../../../components/MCSSpace";
import { AuthContext } from "../../../../context/AuthContext";
import { useEffect } from "react";

function FaqC() {
  const [htmlFileString, setHtmlFileString] = useState(null);

  async function fetchHtml(fileName) {
    // setHtmlFileString(await (await fetch(fileName)).text());
    const response = await fetch(fileName);
    let htmlString = await response.text();
    setHtmlFileString(htmlString);
  }

  const renderFaqDocument = () => {
    return `/feewaiver/faqC.htm`;
  };

  const rerouteToDenied = () => {
    let faqName = 404;
    return `/${faqName}`;
  };

  const FaqContent = (user) => {
    let faqHtmlPath =
      user.entitleId === 900 ? renderFaqDocument() : rerouteToDenied();
    faqHtmlPath = process.env.PUBLIC_URL + faqHtmlPath;
    fetchHtml(faqHtmlPath);
    return <div dangerouslySetInnerHTML={{ __html: htmlFileString }}></div>;
  };

  useEffect(() => {
    const hashtags = document.getElementsByClassName("MsoEndnoteReference");
    for (let i = 0; i < hashtags.length; i++) {
      let anchortag = hashtags[i].closest("a");
      if (
        anchortag.hash != "" &&
        anchortag.href.indexOf(window.location.pathname) == -1
      )
        anchortag.href = window.location.pathname + anchortag.hash;
    }
  });

  return (
    <AuthContext.Consumer>
      {(currentUser) => (
        <>
          <Grid>
            <Row>
              <Col>
                {currentUser &&
                  currentUser.user &&
                  FaqContent(currentUser.user)}
              </Col>
            </Row>
          </Grid>
          <MCSSpace />
        </>
      )}
    </AuthContext.Consumer>
  );
}
export default FaqC;
